module.exports = __webpack_public_path__ + "img/logo-full.ffea034a.png";